"use client";
import * as images from "@/components/images/Images";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { Typography } from "@/components/ui/typography";
import { TranslationDeliverablesCardLink } from "@/components/screen/global-components/translation-deliverables";

const documents = [
  {
    title: "Contract",
    icon: images.Contract,
    href: "/documents/contract",
  },
  {
    title: "E-learning",
    icon: images.E_learning,
    href: "/documents/e-learning",
  },
  {
    title: "Financial Report",
    icon: images.Financial_Report,
    href: "/documents/financial-report",
  },
  {
    title: "Manual",
    icon: images.Manual,
    href: "/documents/manual",
  },
  {
    title: "Patent",
    icon: images.Patent,
    href: "/documents/patent",
  },
  {
    title: "Software",
    icon: images.Software,
    href: "/documents/software",
  },
  {
    title: "Video",
    icon: images.Video,
    href: "/documents/video",
  },
  {
    title: "Website",
    icon: images.Website,
    href: "/documents/website",
  },
];

export default function DocumentsBlock() {
  return (
    <section className="section bg-white lg:bg-background-secondary">
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col md:justify-center md:text-center gap-5 md:gap-2 md:w-full md:max-w-[768px] md:mx-auto">
          <Typography variant="heading4">
            <h2>Specialized experience across documents and digital formats</h2>
          </Typography>
          <div className="flex justify-center text-gray-600">
            <Typography variant="subHeadingSm" asChild>
              <p>
                We match translators with focused expertise fit to your needs
                across a variety of documents, content types, and digital
                formats.
              </p>
            </Typography>
          </div>
        </div>
        <div className="mt-6 lg:mt-12">
          <div className="flex flex-wrap justify-center -m-2">
            {documents.map(({ href, icon, title }, idx) => {
              return (
                <TranslationDeliverablesCardLink
                  key={idx}
                  href={href}
                  imageUrl={icon}
                  imageAlt={title}
                  className="p-2 w-[50%] sm:w-[33.33%] md:w-[25%] lg:w-[20%] flex [&>a]:!pb-5"
                >
                  {title}
                </TranslationDeliverablesCardLink>
              );
            })}
          </div>
        </div>
        <div className="mt-6 lg:mt-12 text-center flex items-center justify-center">
          <Button
            asChild
            variant="primary-outline"
            className="py-3 px-6 h-[48px] w-full sm:w-auto"
          >
            <Link href="/documents" className="!text-base">
              Explore documents
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
